import React, { useContext } from 'react'
import { LayoutContext } from '@components/Context'
import ThinLayout from './ThinLayout'
import RegularLayout from './RegularLayout'

const LayoutSwitch = ({ children, pageContext }) => {
  const layoutContext = useContext(LayoutContext)
  const Layout = (pageContext?.layout !== 'thin' || layoutContext?.showLayout)
    ? RegularLayout
    : ThinLayout
  return (
    <Layout>
      {children}
    </Layout>
  )
}

export default LayoutSwitch
